import PropTypes from 'prop-types'
import useViewport from 'src/hooks/useViewport'
import { Text } from 'src/Components'
import { useFormattedListingAddress } from 'src/hooks/listings'

const propTypes = {
  className: PropTypes.string,
  listing: PropTypes.shape({
    address: PropTypes.shape({
      number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      street: PropTypes.string,
      unitNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      city: PropTypes.string,
      stateOrProvince: PropTypes.string,
      postalCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  }),
}

const defaultProps = {
  className: '',
}

const AddressSection = ({ listing, className }) => {
  const { isMedium } = useViewport()
  const addressObject = useFormattedListingAddress(listing)

  const align = isMedium ? 'center' : 'left'

  return (
    <div className={className}>
      <Text
        weight='bold'
        size={isMedium ? 's' : 'xl'}
        align={align}
        variant='neutralCool'
        variantCount='900'
      >
        {addressObject.firstLineAddress}
      </Text>
      <Text variant='neutralCool' variantCount='700' size='s' align={align}>
        {addressObject.secondLineAddress}
      </Text>
    </div>
  )
}

AddressSection.propTypes = propTypes
AddressSection.defaultProps = defaultProps

export default AddressSection
